module.exports = __webpack_public_path__ + "fonts/SFUIText-MediumItalic.6d79dec9.ttf";